export default class PrivacyModel {
    constructor() {
      this.pageData = {
        title: 'Kebijakan Privasi (Hanya Demo)',
        lastUpdated: this.getFormattedDate()
      };
    }
  
    getPageData() {
      return this.pageData;
    }
  
    getFormattedDate() {
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
        timeZone: 'Asia/Jakarta'
      };
      return new Date().toLocaleDateString('id-ID', options);
    }
  
    getPolicyContent() {
      return {
        sections: [
          {
            id: 'introduction',
            title: '1. Pendahuluan',
            content: 'HeliaEDU berkomitmen untuk melindungi privasi dan keamanan data pribadi pengguna. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi informasi Anda ketika menggunakan platform HeliaEDU.'
          },
          {
            id: 'information-we-collect',
            title: '2. Informasi yang Kami Kumpulkan',
            subsections: [
              {
                title: '2.1 Informasi Pribadi',
                list: [
                  'Nama lengkap yang Anda berikan saat registrasi',
                  'Alamat email untuk verifikasi dan komunikasi',
                  'Kata sandi yang dienkripsi untuk keamanan akun'
                ]
              },
              {
                title: '2.2 Informasi Konten',
                list: [
                  'Postingan dan cerita yang Anda bagikan',
                  'Foto dan gambar yang diunggah',
                  'Data lokasi geografis (opsional)'
                ]
              },
              {
                title: '2.3 Informasi Teknis',
                list: [
                  'Alamat IP dan informasi perangkat',
                  'Data penggunaan aplikasi dan preferensi',
                  'Cookie dan teknologi serupa'
                ]
              }
            ]
          },
          {
            id: 'how-we-use',
            title: '3. Cara Kami Menggunakan Informasi',
            content: 'Informasi yang dikumpulkan digunakan untuk:',
            list: [
              'Menyediakan dan memelihara layanan platform',
              'Memproses dan menampilkan konten yang Anda bagikan',
              'Berkomunikasi dengan Anda terkait layanan',
              'Meningkatkan keamanan dan pengalaman pengguna',
              'Mengirimkan notifikasi push (dengan persetujuan)'
            ]
          },
          {
            id: 'sharing-information',
            title: '4. Berbagi Informasi',
            content: 'Kami tidak menjual atau menyewakan data pribadi Anda kepada pihak ketiga. Informasi hanya dibagikan dalam kondisi berikut:',
            list: [
              'Dengan persetujuan eksplisit dari Anda',
              'Untuk mematuhi kewajiban hukum',
              'Untuk melindungi hak dan keamanan pengguna lain',
              'Dengan penyedia layanan tepercaya yang membantu operasional platform'
            ]
          },
          {
            id: 'data-security',
            title: '5. Keamanan Data',
            content: 'Kami menerapkan langkah-langkah keamanan teknis dan organisasi yang sesuai untuk melindungi data Anda dari akses tidak sah, kehilangan, atau penyalahgunaan. Namun, tidak ada metode transmisi data yang 100% aman.'
          },
          {
            id: 'user-rights',
            title: '6. Hak Pengguna',
            content: 'Anda memiliki hak untuk:',
            list: [
              'Mengakses dan memperbarui informasi pribadi Anda',
              'Menghapus akun dan data terkait',
              'Menolak atau menarik persetujuan pemrosesan data',
              'Meminta portabilitas data',
              'Mengajukan keluhan kepada otoritas perlindungan data'
            ]
          },
          {
            id: 'contact',
            title: '7. Kontak',
            content: 'Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini atau ingin menggunakan hak Anda, silakan hubungi kami:',
            contact: {
              email: 'nananghendystwn@gmail.com',
              name: 'Nanang Hendy S'
            }
          }
        ]
      };
    }
  }